import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import type { RootState } from "../redux/store";

// Define the slice inline
const b2cConfigSlice = createSlice({
	name: "b2cConfig",
	initialState: {
		configLoaded: false,
		b2c: null as any,
	},
	reducers: {
		setConfigLoaded: (state, action: PayloadAction<boolean>) => {
			state.configLoaded = action.payload;
		},
		setB2C: (state, action: PayloadAction<any>) => {
			state.b2c = action.payload;
		},
	},
});

export const { setConfigLoaded, setB2C } = b2cConfigSlice.actions;
export { b2cConfigSlice };

export function useB2CConfig(): any | null {
	const configLoaded = useSelector((state: RootState) => state.config.configLoaded);
	const b2c = useSelector((state: RootState) => state.config.b2c);

	if (!configLoaded) return null;
	return b2c;
}
